"use client";

import { useTraceStore } from "@/store/useTraceStore";
import { PANEL } from "@/config/constants";

interface CompactHeaderProps {
  onReset: () => void;
}

export default function CompactHeader({ onReset }: CompactHeaderProps) {
  const phase = useTraceStore((s) => s.phase);
  const targetUrl = useTraceStore((s) => s.targetUrl);

  return (
    <header className="absolute top-3 left-3 sm:top-5 sm:left-5 z-20 max-w-[calc(100vw-80px)]">
      <div
        className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg"
        style={{
          background: PANEL.BG,
          border: `1px solid ${PANEL.BORDER}`,
          boxShadow: PANEL.SHADOW,
        }}
      >
        <span
          className="text-[13px] font-semibold tracking-[-0.02em]"
          style={{ fontFamily: "var(--font-plus-jakarta)" }}
        >
          <span className="text-[#F4F4F5]">Packet</span>
          <span className="text-[#06B6D4]">Voyager</span>
        </span>
        <div className="w-px h-4 bg-[rgba(255,255,255,0.08)] mx-1" aria-hidden="true" />
        <span className="text-[12px] sm:text-[13px] text-[#06B6D4] font-[family-name:var(--font-geist-mono)] truncate max-w-[120px] sm:max-w-none">
          {targetUrl}
        </span>
        {phase === "loading" && (
          <div
            className="w-4 h-4 border-2 border-[#06B6D4]/30 border-t-[#06B6D4] rounded-full animate-spin"
            role="status"
            aria-label="Loading trace"
          />
        )}
        <button
          onClick={onReset}
          className="ml-2 text-[#71717A] hover:text-[#F4F4F5] transition-colors cursor-pointer"
          aria-label="Close trace and reset"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </header>
  );
}
